import { get, put, remove } from '../Services/http';
import { catchError } from './Error.action';
import { CART_LOAD_ERROR, CART_RECEIVE, CART_SHOW_INFO, CART_SET_BANNER_MESSAGE } from '../constants';
import { showSpinner, hideSpinner } from './LoadingSpinner.action';

export const load = () => (dispatch, getState) => {
    return get('/api/cart')
        .then((response) => response.json())
        .then((cart) => {
            dispatch(receive(cart));
        })
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
};

export const loadError = (error) => ({
    type: CART_LOAD_ERROR,
    payload: {
        error,
    },
});

export const receive = (cart) => ({
    type: CART_RECEIVE,
    payload: cart,
});

export const toggle = () => (dispatch, getState) => {
    dispatch(show(!getState().cart.showInfo));
};

const show = (visible) => ({
    type: CART_SHOW_INFO,
    payload: {
        showInfo: visible,
    },
});

export const update = (articleNumber, quantity, abortController = null) => (
    dispatch
) => {
    return put(`/api/cart/update`, { articleNumber, quantity }, abortController)
        .then((response) => response.json())
        .then((cart) => dispatch(receive(cart)))
        .catch((ex) => {
            dispatch(catchError(ex, (error) => loadError(error)));
            throw ex;
        });
};

export const updateDiscount = (articleNumber, discount, abortController = null) => (
    dispatch
) => {
    return put(`/api/cart/discount`, { articleNumber, discount }, abortController)
        .then((response) => response.json())
        .then((cart) => dispatch(receive(cart)))
        .catch((ex) => {
            dispatch(catchError(ex, (error) => loadError(error)));
            throw ex;
        });
};

export const clear = (abortController = null) => (
    dispatch
) => {
    dispatch(showSpinner());
    return remove(`/api/cart`, abortController)
        .then((response) => response.json())
        .then((cart) => {
            dispatch(receive(cart))
            dispatch(hideSpinner())
        })
        .catch((ex) => {
            dispatch(catchError(ex, (error) => loadError(error)));
            dispatch(hideSpinner())
            throw ex;
        });
};

export const setBannerMessage = (banner) => ({
    type: CART_SET_BANNER_MESSAGE,
    payload: {
        messageBanners: {
            banners: [banner]
        }
    },
});